import { useQuery } from "@tanstack/react-query";
import stablePriceService from "../services/stablePrice";


export const useStablePrice = () => {

  return useQuery({
    queryKey: ['stablePrice'],
    queryFn: stablePriceService.fetchStablePrice,
    staleTime: 1000 * 60 * 30
  })

}